exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.confirmTips .el-message-box__container{\n  text-align: center;\n}\n.confirmTips .el-icon-warning{\n  padding-right: 5px;\n  color: #E6A23C;\n  font-size: 24px;\n  vertical-align: bottom;\n}\n", ""]);

// exports
